module.exports = __webpack_public_path__ + "static/media/screen-stellaraio.f9dcbaba.png";